const KEY = 'freebetCredits';

export function request( state, { customerId } ) {
    return state.setIn( [ KEY, customerId, 'addStatus' ], 'IN_PROGRESS' );
}

export function error( state, { customerId } ) {
    return state.setIn( [ KEY, customerId, 'addStatus' ], 'ERROR' );
}

export function finish( state, { customerId } ) {
    return state.setIn( [ KEY, customerId, 'addStatus' ], 'FINISHED' );
}
